import { render, staticRenderFns } from "./SatchelExport.vue?vue&type=template&id=54d1eb66"
import script from "./SatchelExport.vue?vue&type=script&lang=js"
export * from "./SatchelExport.vue?vue&type=script&lang=js"
import style0 from "./SatchelExport.vue?vue&type=style&index=0&id=54d1eb66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports